import React, { useEffect, useRef, useState } from "react";
import "./EditPassengersDetails.css";
import {
  Box,
  Button,
  CheckBox,
  Form,
  FormField,
  Layer,
  RadioButtonGroup,
  Select,
  Text,
  TextInput,
} from "grommet";
import { Input } from "rsuite";
import { RootStore } from "../../../../../../store/RootStore";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import PassengerService from "../../../../../../services/passenger/passenger.service";
import close from "../../../../../../assets/close_small (1).svg";
import leftarrow from '../../../../../../assets/arrow-left.svg';
import rightarrow from '../../../../../../assets/arrow-right (5).svg';
import { useLocation, useNavigate } from "react-router-dom";
import { Mixpanel } from "../../../../../../util/Helper";

const EditPassengersDetails = observer(() => {
  const [buttonEnable, setButtonEnable] = useState(false);
  const { rootStore } = useStore();
  const navigate = useNavigate();
  // const history = useLocation();

  const prevAgeRef = useRef(rootStore.passengerStore.getPassengerAge || '');

  const [isChronicDisease, setIsChronicDisease] = useState(false);
  const [isChronicDisease1, setIsChronicDisease1] = useState("");
  const [chronicDiseaseDetails, setChronicDiseaseDetails] = useState("");
  const [physicallyDisabledDetails, setPhysicallyDisabledDetails] =
    useState("");

  const clearFormStates = () => {
    rootStore.passengerStore.handleEditPassengersName("");
    rootStore.passengerStore.handleEditPassengerAge("");
    rootStore.passengerStore.handleEditPassengerEmail("");
    rootStore.passengerStore.handleEditPassengerAdress("");
    rootStore.passengerStore.handleEditPassengersContactNumber("");
    rootStore.passengerStore.handleEditPassengerInput5(false);
    rootStore.passengerStore.handleEditPassengerInput6(false);
    rootStore.passengerStore.handleEditPassengerPhysicallyDisabled(false);
    rootStore.passengerStore.handleEditPassengerInput0(false);
    rootStore.passengerStore.handleEditPassengerInput00("");
    rootStore.passengerStore.handleEditPassengerInput1("");
    rootStore.passengerStore.handleEditPassengerInput2("");
    rootStore.passengerStore.handleEditPassengerInput3("");
    rootStore.passengerStore.handleEditPassengerInput4("");
    rootStore.passengerStore.handleEditPassengerInput05("");
    rootStore.passengerStore.handleEditPassengerInput06("");
  };

  const ChangeStateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!rootStore.passengerStore.getSelectedOrgId) {
      rootStore.notificationToastStore.showNotification('Please select organization.', true);
      return;
    } if (!rootStore.passengerStore.getEditPassengersGender) {
      rootStore.notificationToastStore.showNotification('Please enter gender.', true);
      return;
    } else if (!rootStore.passengerStore.getEditPassengersName) {
      rootStore.notificationToastStore.showNotification('Please enter passenger name.', true);
      return;
    } else if (!rootStore.passengerStore.getEditPassengerAge) {
      rootStore.notificationToastStore.showNotification('Please enter passenger age.', true);
      return;
    } 
    // else if (!rootStore.passengerStore.getEditPassengersContactNumber) {
    //   rootStore.notificationToastStore.showNotification('Please enter passenger contact number.', true);
    //   return;
    // } 
    else if (!emailRegex.test(rootStore.passengerStore.getEditPassengerEmail)) {
      rootStore.notificationToastStore.showNotification('Please enter valid email.', true);
      return;
    } else {
      rootStore.passengerStore.handlChangeEditForm(false);
    }
  };

  const handleSubmit = async (e) => {
    setButtonEnable(true);
    e.preventDefault();

    const uInfo = localStorage.getItem("userinfo");
    const userInformation = JSON.parse(uInfo);
    Mixpanel.track("web_edit_passenger", { name: userInformation.name });

    const passengerData = {
      id: rootStore.passengerStore.getPassengerId,
      name: rootStore.passengerStore.getEditPassengersName,
      // contactNumber: rootStore.passengerStore.getEditPassengersContactNumber,
      email: rootStore.passengerStore.getEditPassengerEmail,
      age: rootStore.passengerStore.getEditPassengerAge,
      address: rootStore.passengerStore.getEditPassengerAdress,
      gender: rootStore.passengerStore.getEditPassengersGender.toUpperCase(),
      // orgId: rootStore.passengerStore.getSelectedOrgId
    };

    try {
      await PassengerService.updatePassenger(passengerData);
      let response = await PassengerService.getQuestionList();
      console.log("passenger history question", response);
      let updateQuestion = {};
      for (const question of response) {
      console.log(question.id);
      let answere = await PassengerService.getAnswereById(rootStore.passengerStore.getPassengerId, question.id);
        console.log("answere", answere);
        if (answere.length > 0) {
          switch (question.id) {
            case 3:
              if (answere[0].answer != rootStore.passengerStore.getEditPassengerAnyChronicDisease1 && rootStore.passengerStore.getEditPassengerAnyChronicDisease1.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerAnyChronicDisease1;
              }
              break;
            case 4:
              if (answere[0].answer != rootStore.passengerStore.getEditPassengerPhysicallyDisabledAns && rootStore.passengerStore.getEditPassengerPhysicallyDisabledAns.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerPhysicallyDisabledAns;
              }
              break;
            case 5:
              if (answere[0].answer != rootStore.passengerStore.getEditPassengerInput00 && rootStore.passengerStore.getEditPassengerInput00.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput00;
              }
              break;
            case 6:
              if (answere[0].answer != rootStore.passengerStore.getEditPassengerInput1) {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput1;
              }
              break;
            case 7:
              if (answere[0].answer != rootStore.passengerStore.getEditPassengerInput3) {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput3;
              }
              break;
            case 8:
              if (answere[0].answer.toLowerCase() != rootStore.passengerStore.getEditPassengerInput4) {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput4;
              }
              break;
            case 9:
              if (answere[0].answer != rootStore.passengerStore.getEditPassengerInput05 && rootStore.passengerStore.getEditPassengerInput05.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput05;
              }
              break;
            case 10:
              if (answere[0].answer != rootStore.passengerStore.getEditPassengerInput06  && rootStore.passengerStore.getEditPassengerInput06.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput06;
              }
              break;
            default:
              break;
          }
        } else {
          switch (question.id) {
            case 3:
              if (rootStore.passengerStore.getEditPassengerAnyChronicDisease1 != "" && rootStore.passengerStore.getEditPassengerAnyChronicDisease1.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerAnyChronicDisease1;
              }
              break;
            case 4:
              if (rootStore.passengerStore.getEditPassengerPhysicallyDisabledAns != "" && rootStore.passengerStore.getEditPassengerPhysicallyDisabledAns.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerPhysicallyDisabledAns;
              }
              break;
            case 5:
              if (rootStore.passengerStore.getEditPassengerInput00 != "" && rootStore.passengerStore.getEditPassengerInput00.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput00;
              }
              break;
            case 6:
              if (rootStore.passengerStore.getEditPassengerInput1 != "") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput1;
              }
              break;
            case 7:
              if (rootStore.passengerStore.getEditPassengerInput3 != "") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput3;
              }
              break;
            case 8:
              if (rootStore.passengerStore.getEditPassengerInput4 != "") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput4;
              }
              break;
            case 9:
              if (rootStore.passengerStore.getEditPassengerInput05 != "" && rootStore.passengerStore.getEditPassengerInput05.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput05;
              }
              break;
            case 10:
              if (rootStore.passengerStore.getEditPassengerInput06 != "" && rootStore.passengerStore.getEditPassengerInput06.toLowerCase() != "no") {
                updateQuestion[question.id] = rootStore.passengerStore.getEditPassengerInput06;
              }
              break;
            default:
              break;
          }
        }
     
      }

      const passengerMedicalHistory = {
        queAns: updateQuestion,
        passengerId: rootStore.passengerStore.getPassengerId
      }

      await PassengerService.addAnswere(passengerMedicalHistory);
      rootStore.notificationToastStore.showNotification(
        "Passenger updated successfully",
        false,
        3000
      );
      setButtonEnable(false);
      rootStore.passengerStore.handleIsEditPassengerOpen(false);
      rootStore.passengerStore.handleupdate();
      clearFormStates();
    } catch (error) {
      setButtonEnable(false);
      console.error("Error handling passenger:", error);
      rootStore.notificationToastStore.showNotification(
        "Failed to update Passenger. Please try again later.",
        true,
        3000
      );
    }
  };

  useEffect(() => {
    (async () => {
      let organizations = await PassengerService.getOrganizations();
      rootStore.passengerStore.handleCreatePassengerOrgList(organizations);
      let uTnfo = localStorage.getItem("userinfo");
      let passengerInformation = JSON.parse(uTnfo);
      rootStore.passengerStore.handlePassengerLabel(
        passengerInformation.roleLabel
      );
      if (passengerInformation.roleLabel.toLowerCase() == "admin,superadmin") {
        let passengerOrg = await PassengerService.getOrgByUserName(
          passengerInformation.username
        );
        rootStore.passengerStore.handleSelectedOrgId(passengerOrg.id);
      }
    })(); // Immediately invoke the async function

    return () => {
      rootStore.passengerStore.handlChangeEditForm(true);
    }
  }, []);

  // --- AGE input helpers ---
  const handleAgeKeyDown = (evt) => {
    // Allow control/meta keys
    if (evt.ctrlKey || evt.metaKey || evt.altKey) return;
    const allowedKeys = ['Backspace','Delete','ArrowLeft','ArrowRight','Home','End','Tab'];
    if (allowedKeys.includes(evt.key)) return;

    // Only allow single digit keys
    if (!/^[0-9]$/.test(evt.key)) {
      evt.preventDefault();
    }
  };

  const handleAgeChange = (e) => {
    const raw = e.target.value || '';
    // remove non-digits
    const digits = raw.replace(/\D/g, '');

    if (digits === '') {
      // empty input allowed (user might be clearing)
      rootStore.passengerStore.handleEditPassengerAge('');
      prevAgeRef.current = '';
      return;
    }

    // Remove leading zeros by parsing number
    const numeric = parseInt(digits, 10);
    if (isNaN(numeric)) {
      // revert to previous valid value
      rootStore.passengerStore.handleEditPassengerAge(prevAgeRef.current || '');
      return;
    }

    // If numeric > 120, revert to previous valid value (do not accept)
    if (numeric > 120) {
      // keep previous valid value (prevents entering >120)
      rootStore.passengerStore.handleEditPassengerAge(prevAgeRef.current || '');
      return;
    }

    // Accept the numeric value (no leading zeros)
    const newVal = String(numeric);
    rootStore.passengerStore.handleEditPassengerAge(newVal);
    prevAgeRef.current = newVal;
  };

  const handleAgePaste = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData('text') || '';
    const digits = paste.replace(/\D/g, '');
    if (!digits) return;

    const numeric = parseInt(digits, 10);
    if (isNaN(numeric) || numeric > 120) {
      // ignore paste if invalid or >120
      return;
    }

    const newVal = String(numeric);
    rootStore.passengerStore.handleEditPassengerAge(newVal);
    prevAgeRef.current = newVal;
  };
  // --- end AGE helpers ---

  const [emailError, setEmailError] = useState('');

  return (
    <Layer
    style={{
      borderRadius: "12px 0px 0px 0px",
      width: "700px",
      height: "100%",
      overflow:"auto",
      // padding: "0px 26px 7px 0px"

    }}
    onClickOutside={() => {
      rootStore.passengerStore.handleIsEditPassengerOpen(false);
    }}
    onEsc={() => {
      rootStore.passengerStore.handleIsEditPassengerOpen(false);
    }}
    full="vertical"
    position="right"
    >


    <Box className="Edit-passengers-container">
      <Box className="Edit-passengers-header">
        <Text className="header-text-1">Edit Passenger’s Detail</Text>
        <Button
              className="close-btn"
              style={{
                color: "#357EFF",
                fontFamily: "Inter",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "16px"}}
              onClick={() => rootStore.passengerStore.handleIsEditPassengerOpen(false)}
            >
              <img src={close} alt="close" />
              
              Close
            </Button>
  
      </Box>
    
      <div style={{padding:"14px 23px 23px"}}>
      {rootStore.passengerStore.getChangeEditForm ? (
        <Form validate="change" className="middle-container">
              <Text style={{
                color: "var(--Grey-3, #A7B6D1)",
                textAlign: "left",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "italic",
                fontWeight: "600",
                lineHeight: "20px",
              marginBottom:"12px"
              }}>**Demographics**</Text>
          <Box className="middle-form-box">
            <FormField
              className="Edit-passenger-form-F1
          "
            >
              <div
                className="Edit-user-modal-form-L7"
                style={{ width: "100%", marginBottom: 16 }}
              >
                <label className="Edit-passenger-form-L1">Organization</label>
                <div
                  className={
                    (rootStore.passengerStore.getPassengerLabel.toLowerCase() ==
                      "admin" || rootStore.passengerStore.getPassengerLabel.toLowerCase() ==
                      "superadmin")
                      ? "disable-passenger-org-outer"
                      : "Edit-user-sadmin"
                  }
                >
                  <Select
                    style={{
                      width: "100%",
                    }}
                    name="organization"
                    labelKey={"label"}
                    defaultValue={"Select"}
                    valueKey={{ key: "value", reduce: true }}
                    options={rootStore.passengerStore.getCreatePassengerOrgList?.map(
                      (org) => {
                        return {
                          label: org.name,
                          value: org.id,
                        };
                      }
                    )}
                    value={rootStore.passengerStore.getSelectedOrgId ?? null}
                    onChange={(event) => {
                      if (rootStore.passengerStore.getPassengerLabel.toLowerCase() != "admin" && rootStore.passengerStore.getPassengerLabel.toLowerCase() != "superadmin") {
                        rootStore.passengerStore.handleSelectedOrgId(
                          event.option.value
                        );
                      }
                    }}
                  />
                </div>
              </div>
              <FormField className="check-radio" style={{ width: "100%", marginBottom: 16 }}>
                <label
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                  className="Edit-passenger-form-L1"
                >
                  Passenger’s Genger
                </label>
                <RadioButtonGroup
                  name="doc"
                  options={["MALE", "FEMALE", "OTHERS"]}
                  value={rootStore.passengerStore.getEditPassengersGender}
                  onChange={(event) =>
                    rootStore.passengerStore.handleEditPassengersGenger(
                      event.target.value.toUpperCase()
                    )
                  }
                  className="form-group"
                />
              </FormField>
            </FormField>
          <div style={{display:"flex",gap:"40px",marginBottom: 16}}>
          <Box className="middle-form-flex">
              <FormField
                className="Edit-passenger-form-F1"
                name="editPassengerName"
                htmlFor="edit-passenger-name-id"
                placeholder="Passenger’s Name"
                validate={[
                  {
                    regexp: /^[a-zA-Z\s]+$/,
                    message: "Passenger’s name can only contain letters and spaces.",
                  }
                ]}
              >
                <label className="Edit-passenger-form-L1">
                  Passenger’s Name
                </label>
                <TextInput
                  type="text"
                  className="Edit-passenger-form-I2"
                  placeholder="Enter Here"
                  id="edit-passenger-name-id"
                  name="editPassengerName"
                  maxLength={100}
                  value={rootStore.passengerStore.getEditPassengersName}
                  onChange={(event) => {
                    rootStore.passengerStore.handleEditPassengersName(event.target.value);
                  }}
                />
              </FormField>
            </Box>
            <Box className="middle-form-flex">
              <FormField className="Edit-passenger-form-F1">
                <label className="Edit-passenger-form-L1">
                  Passenger’s Age
                </label>
                {/* <TextInput
                  type="number"
                  className="Edit-passenger-form-I2"
                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                  value={rootStore.passengerStore.getEditPassengerAge}
                  onChange={(event) => {
                    rootStore.passengerStore.handleEditPassengerAge(
                      event.target.value
                    );
                  }}
                  placeholder="Enter Here"
                /> */}
                <TextInput
                  type="number"
                  className="add-passenger-form-I2"
                  onKeyDown={handleAgeKeyDown}
                  onChange={handleAgeChange}
                  onPaste={handleAgePaste}
                  value={rootStore.passengerStore.getEditPassengerAge}
                  placeholder="Enter Here"
                  maxLength={3}
                />
              </FormField>
         
            </Box>
          </div>
            <Box className="middle-form-flex" style={{marginBottom: 16}}>
            {/* <FormField className="Edit-passenger-form-F1">
                <label className="Edit-passenger-form-L1">
                  Passenger’s Contact Number
                </label>
                <TextInput
                  type="number"
                  className="Edit-passenger-form-I2"
                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                  value={
                    rootStore.passengerStore.getEditPassengersContactNumber
                  }
                  onChange={(e) => {
                    rootStore.passengerStore.handleEditPassengersContactNumber(
                      e.target.value
                    );
                  }}
                  placeholder="Enter Here"
                />
              </FormField> */}
              <FormField
                className="Edit-passenger-form-F1"
                name="email"
                htmlFor="emailinput-id"
                error={emailError || undefined} 
              >
                <label className="Edit-passenger-form-L1">
                  Passenger’s Email
                </label>
                <TextInput
                  type="email"
                  id="emailinput-id"
                  maxLength={50}
                  className="Edit-passenger-form-I2"
                  // formNoValidate=" /^[a-zA-Z0-9.! #$%&'*+/=? ^_`{|}~-]+@[a-zA-Z0-9-]+(?:\. [a-zA-Z0-9-]+)*$/."
                  value={rootStore.passengerStore.getEditPassengerEmail}
                  onChange={(event) => {
                    const value = event.target.value.trim(); // sanitize spaces
                    rootStore.passengerStore.handleEditPassengerEmail(
                      value
                    );

                    const emailRegex =
/^(?!.*\.\.)(?!\.)([a-zA-Z0-9._%+-]+[a-zA-Z0-9_+-])@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


                    if (value && !emailRegex.test(value)) {
                      setEmailError("Invalid email format.");
                    } else {
                      setEmailError('');
                    }
                  }}
                  placeholder="Enter Here"
                />
              </FormField>
            </Box>
            <FormField className="Edit-passenger-form-F1" style={{marginBottom: 16}}>
              <label className="Edit-passenger-form-L1">
                Passenger’s Address
              </label>
              <TextInput
                type="text"
                className="Edit-passenger-form-I2"
                value={rootStore.passengerStore.getEditPassengerAdress}
                maxLength={100}
                onChange={(event) => {
                  rootStore.passengerStore.handleEditPassengerAdress(
                    event.target.value
                  );
                }}
                placeholder="Enter Here"
              />
            </FormField>
          </Box>
          <div className="active-page-info">
                <div className="inner">
                <img style={{cursor: 'no-drop',opacity: .5}} className='arrow left-arrow' src={leftarrow} alt="leftarrow" />
                  <span className="active">1</span>
                  <span onClick={() => rootStore.passengerStore.handlChangeEditForm(false)}>2</span>
                  <img className='arrow right-arrow' onClick={() => rootStore.passengerStore.handlChangeEditForm(false)} src={rightarrow} alt="leftarrow" />
                </div>
          </div>
          <Box className="Edit-passenger-footer">
            <Button
              className="footer-btn-1"
              onClick={() => navigate("/passengers")}
            >
              Cancel
            </Button>
            <Button
              className="footer-btn-2"
              primary
              label="Next"
              onClick={ChangeStateForm}
            />
          </Box>
        </Form>
      ) : (
        <></>
      )}
      {!rootStore.passengerStore.getChangeEditForm ? (
        <Form className="middle-container" onSubmit={handleSubmit}>
              <Text style={{
                color: "var(--Grey-3, #A7B6D1)",
                textAlign: "left",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "italic",
                fontWeight: "600",
                lineHeight: "20px",
                marginBottom:"12px"
              }}>**Medical History**</Text>
          <Box className="middle-form2-box">
            <FormField className="Edit-passenger-form2-F1">
              <label className="Edit-passenger-form2-L1">
              Does the individual or their family have any chronic conditions like diabetes, hypertension, asthma, or heart disease?
              </label>
              <div className="form-group">
                <div className="gender-options">
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "5px",
                    }}
                  >
                    <label
                      style={{
                        color: "#333",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "16px"
                      }}
                    >
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="yes/no"
                        value="Yes"
                        checked={rootStore.passengerStore.getEditPassengerAnyChronicDisease}
                        onChange={() =>
                          rootStore.passengerStore.handleEditPassengerAnyChronicDisease(
                            true
                          )
                        }
                      />
                      Yes
                    </label>
                    <TextInput
                      required
                      style={{
                        border: "none",
                        width: "200px",
                        height: "48px",
                        padding: "12px 14px",
                        borderRadius: "10px",
                        background: "#F2F7FF",
                        color: "#41454B",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "16px",
                        fontStyle: "italic",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "22px",
                      }}
                      maxLength={100}
                      placeholder="Enter Here"
                      value={rootStore.passengerStore.getEditPassengerAnyChronicDisease1}
                      onChange={(e) =>
                        rootStore.passengerStore.handleEditPassengerAnyChronicDisease1(e.target.value)
                      }
                      disabled={!rootStore.passengerStore.getEditPassengerAnyChronicDisease}
                    />

                    <label
                      style={{
                        color: "#333",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "16px",
                      }}
                    >
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="yes/no"
                        value="No"
                        checked={!rootStore.passengerStore.getEditPassengerAnyChronicDisease}
                        onChange={() => {
                          rootStore.passengerStore.handleEditPassengerAnyChronicDisease(
                            false
                          );
                          rootStore.passengerStore.handleEditPassengerAnyChronicDisease1("");
                        }}
                      />
                      No
                    </label>
                  </Box>
                </div>
              </div>
            </FormField>
            <Box className="middle-form2-flex">
              <FormField className="Edit-passenger-form2-F1">
                <label className="Edit-passenger-form2-L1">Impaired</label>
                <div className="form-group">
                  <div className="gender-options">
                  <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "5px",
                      }}
                    >
                    <label
                      style={{
                        color: "#333",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "16px",
                      }}
                    >
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="covid-diagnosed1"
                        value="Yes"
                        checked={rootStore.passengerStore.getEditPassengerPhysicallyDisabled}
                        onChange={() =>
                          rootStore.passengerStore.handleEditPassengerPhysicallyDisabled(true)
                        }
                      />
                      Yes
                    </label>
                    <TextInput
                        required
                        style={{
                          border: "none",
                          width: "200px",
                          height: "48px",
                          padding: "12px 14px",
                          borderRadius: "10px",
                          background: "#F2F7FF",
                          color: "#41454B",

                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "22px",
                        }}
                        maxLength={100}
                        placeholder="Enter Here"
                        name="medicationsttt"
                        type="text"
                        value={rootStore.passengerStore.getEditPassengerPhysicallyDisabledAns}
                        onChange={(e) =>
                          rootStore.passengerStore.handleEditPassengerPhysicallyDisabledAns(e.target.value)
                        }
                        disabled={!rootStore.passengerStore.getEditPassengerPhysicallyDisabled}
                      />
                      </Box>
                    <label
                      style={{
                        color: "#333",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: "500",
                        lineHeight: "16px",
                      }}
                    >
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="covid-diagnosed1"
                        value="No"
                        checked={!rootStore.passengerStore.getEditPassengerPhysicallyDisabled}
                        onChange={() =>
                          {rootStore.passengerStore.handleEditPassengerPhysicallyDisabled(false);
                          rootStore.passengerStore.handleEditPassengerPhysicallyDisabledAns("");}
                        }
                      />
                      No
                    </label>
                  </div>
                </div>
              </FormField>
            </Box>

            <Box className="middle-form2-flex" style={{ marginTop: "10px" }}>
               <FormField className="Edit-passenger-form2-F1">
                <label className="Edit-passenger-form2-L1">
                Is the passenger currently taking any medications?
                </label>
              <div className="form-group">
                  <div className="gender-options">
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "5px",
                      }}
                    >
                       <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                      <input
                        style={{ width: "16px", height: "16px" }}
                        type="radio"
                        name="medicationsttt"
                        value="Yes"
                        checked={rootStore.passengerStore.getEditPassengerInput0}
                        onChange={() =>rootStore.passengerStore.handleEditPassengerInput0(true)}
                      />
                        Yes
                      </label>
                        <TextInput
                          required
                          style={{
                            border: "none",
                            width: "200px",
                            height: "48px",
                            padding: "12px 14px",
                            borderRadius: "10px",
                            background: "#F2F7FF",
                            color: "#41454B",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "22px",
                          }}
                          maxLength={100}
                          placeholder="Enter Here"
                          value={rootStore.passengerStore.getEditPassengerInput00}
                          onChange={(e) =>
                            rootStore.passengerStore.handleEditPassengerInput00(
                              e.target.value
                            )
                          }
                          disabled={!rootStore.passengerStore.getEditPassengerInput0}
                        />
                      <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name="medicationsttt"
                          value="No"
                          checked={!rootStore.passengerStore.getEditPassengerInput0}
                          onChange={() => {
                            rootStore.passengerStore.handleEditPassengerInput0(
                              false
                            );
                            rootStore.passengerStore.handleEditPassengerInput00(
                              ""
                            ); // Reset TextInput value to empty string when switching to "No"
                          }} // Disable input when No is selected
                        />
                        No
                      </label>
                    </Box>
                  </div>
                </div>
              </FormField> 
            </Box>

            <Box className="middle-form2-flex">
              <FormField className="Edit-passenger-form2-F1">
                <label className="Edit-passenger-form2-L1">
                Has the passenger recently been hospitalized for any serious illnesses, injuries, or surgeries? If so, when and why?
                </label>
                <TextInput
                  type="text"
                  className="Edit-passenger-form2-I3"
                  maxLength={100}
                  value={rootStore.passengerStore.getEditPassengerInput1}
                  onChange={(e) => {rootStore.passengerStore.handleEditPassengerInput1(e.target.value)}
                  }
                  placeholder="Enter Here"
                />
              </FormField>
            </Box>
            <Box className="middle-form2-flex">
              <FormField className="Edit-passenger-form2-F1">
                <label className="Edit-passenger-form2-L1">Does the passenger have any allergies to medications, foods, or other substances?</label>
                <TextInput
                  type="text"
                  className="Edit-passenger-form2-I3"
                  maxLength={100}
                  value={rootStore.passengerStore.getEditPassengerInput3}
                  onChange={(e) =>
                    rootStore.passengerStore.handleEditPassengerInput3(
                      e.target.value
                    )
                  }
                  placeholder="Enter Here"
                />
              </FormField>
            </Box>
            <Box className="middle-form2-flex">
              <FormField className="Edit-passenger-form2-F1">
                <label className="Edit-passenger-form2-L1">Has the passenger been diagnosed with COVID-19 in the past 6 months?</label>
                <div className="form-group">
                  <div className="gender-options">
                     <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name="covid"
                          value="Yes"
                          checked={rootStore.passengerStore.getEditPassengerInput4 == "yes"}
                          onChange={() => {
                            rootStore.passengerStore.handleEditPassengerInput4("yes");
                          }}
                        />
                        Yes
                      </label>
                      <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name="covid"
                          value="No"
                          checked={rootStore.passengerStore.getEditPassengerInput4.toLowerCase() == "no" || rootStore.passengerStore.getEditPassengerInput4 == ""}
                          onChange={() => {
                            rootStore.passengerStore.handleEditPassengerInput4("no");
                          }}
                        />
                        No
                      </label>
                  </div>
                </div>
              </FormField>
            </Box>

            <Box className="middle-form2-flex" style={{ marginTop: "10px" }}>
              <FormField className="Edit-passenger-form2-F1">
                <label className="Edit-passenger-form2-L1">Does the passenger currently have any symptoms of illness, such as fever, cough, or shortness of breath?</label>
                <div className="form-group">
                  <div className="gender-options">
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name="symptoms"
                          value="Yes"
                          checked={rootStore.passengerStore.getEditPassengerInput5}
                          onChange={() => {
                            rootStore.passengerStore.handleEditPassengerInput5(true);
                          }} // Enable input when Yes
                        />
                        Yes
                      </label>

                      <TextInput
                        required
                        style={{
                          border: "none",
                          width: "200px",
                          height: "48px",
                          padding: "12px 14px",
                          borderRadius: "10px",
                          background: "#F2F7FF",
                          color: "#41454B",

                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "22px",
                        }}
                        maxLength={100}
                        placeholder="Enter Here"
                        name="symptoms"
                        value={rootStore.passengerStore.getEditPassengerInput05}
                        onChange={(e) =>
                          rootStore.passengerStore.handleEditPassengerInput05(
                            e.target.value
                          )
                        }
                        disabled={!rootStore.passengerStore.getEditPassengerInput5}
                      />

                      <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name="symptoms"
                          value="No"
                          checked={!rootStore.passengerStore.getEditPassengerInput5}
                          onChange={() => {
                            rootStore.passengerStore.handleEditPassengerInput5(
                              false
                            );
                            rootStore.passengerStore.handleEditPassengerInput05(
                              ""
                            );
                          }} // Disable input when No is selected
                        />
                        No
                      </label>
                    </Box>
                  </div>
                </div>
              </FormField>
            </Box>

            <Box className="middle-form2-flex" style={{ marginTop: "10px" }}>
              <FormField className="Edit-passenger-form2-F1">
                <label className="Edit-passenger-form2-L1">Does the passenger have any other medical conditions or concerns we should be aware of?</label>
                <div className="form-group">
                  <div className="gender-options">
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "5px",
                      }}
                    >
                      <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name="medicationDetails"
                          checked={rootStore.passengerStore.getEditPassengerInput6}
                          value="Yes"
                          onChange={() => {
                            rootStore.passengerStore.handleEditPassengerInput6(
                              true
                            );
                            // Enable input when Yes
                          }}
                        />
                        Yes
                      </label>

                      <TextInput
                        required
                        style={{
                          border: "none",
                          width: "200px",
                          height: "48px",
                          padding: "12px 14px",
                          borderRadius: "10px",
                          background: "#F2F7FF",
                          color: "#41454B",

                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: "500",
                          lineHeight: "22px",
                        }}
                        maxLength={100}
                        placeholder="Enter Here"
                        name="medicationDetails"
                        value={rootStore.passengerStore.getEditPassengerInput06}
                        onChange={(e) =>
                          rootStore.passengerStore.handleEditPassengerInput06(
                            e.target.value
                          )
                        }
                        disabled={!rootStore.passengerStore.getEditPassengerInput6}
                      />

                      <label
                        style={{
                          color: "#333",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: "500",
                          lineHeight: "16px",
                        }}
                      >
                        <input
                          style={{ width: "16px", height: "16px" }}
                          type="radio"
                          name="medicationDetails"
                          value="No"
                          checked={!rootStore.passengerStore.getEditPassengerInput6}
                          onChange={() => {
                            rootStore.passengerStore.handleEditPassengerInput6(
                              false
                            );
                            rootStore.passengerStore.handleEditPassengerInput06(
                              ""
                            ); // Set input state to false // Clear input field
                          }}
                        />
                        No
                      </label>
                    </Box>
                  </div>
                </div>
              </FormField>
            </Box>
            <div className="active-page-info">
                <div className="inner">
                  <img className='arrow left-arrow' onClick={() => rootStore.passengerStore.handlChangeEditForm(true)} src={leftarrow} alt="leftarrow" />
                  <span onClick={() => rootStore.passengerStore.handlChangeEditForm(true)}>1</span>
                  <span className="active">2</span>
                  <img className='arrow right-arrow' style={{cursor: 'no-drop',opacity: .5}} src={rightarrow} alt="leftarrow" />
                </div>
          </div>
            <Box className="Edit-passenger-footer">
              <Button
                className="footer-btn-1"
                disabled={buttonEnable}
                onClick={() => {
                  rootStore.passengerStore.handlChangeEditForm(true);
                }}
              >
                Back
              </Button>
              <Button className="footer-btn-2" disabled={buttonEnable} type="submit" label="Save"  />
            </Box>
          </Box>
        </Form>
      ) : (
        <></>
      )}
    </div>
    </Box>
    </Layer>
  );
});

export default EditPassengersDetails;
